/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetWalletsResponseEthItemWalletType = typeof GetWalletsResponseEthItemWalletType[keyof typeof GetWalletsResponseEthItemWalletType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWalletsResponseEthItemWalletType = {
  ETH: 'ETH',
  BTC: 'BTC',
  LTC: 'LTC',
  BCH: 'BCH',
  XRP: 'XRP',
  DOT: 'DOT',
  ADA: 'ADA',
  DOGE: 'DOGE',
  TRX: 'TRX',
  ARB: 'ARB',
  BSV: 'BSV',
} as const;
